import { useState } from "react";
import { NavLink } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { HashLink } from "react-router-hash-link";

import image1 from "../img/utpl.png";

function Header() {
  const [open, setOpen] = useState(false);

  return (
    <motion.header
      initial={{ y: -70, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{
        duration: 0.7,
        ease: [0.22, 1, 0.36, 1],
      }}
      className="
        sticky
        top-0
        z-50
        bg-[#004270]/95
        backdrop-blur-md
        shadow-lg
        border-b
        border-white/10
      "
    >
      <div className="max-w-6xl mx-auto flex items-center justify-between py-4 px-6">
        {/* Logo */}
        <NavLink to="/" className="group">
          <motion.img
            src={image1}
            alt="UTPL"
            className="h-8 w-auto"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.97 }}
            transition={{ duration: 0.2 }}
          />
        </NavLink>

        {/* Menú escritorio */}
        <nav className="hidden md:flex items-center gap-2">
          <HashLink
            smooth
            to="/#inicio"
            className="text-white px-3 hover:text-[#febe10]"
          >
            Inicio
          </HashLink>

          <HashLink
            smooth
            to="/#call-for-papers"
            className="text-white px-3 hover:text-[#febe10]"
          >
            Call for papers
          </HashLink>
          <HashLink
            smooth
            to="/#inscripcion"
            className="
    ml-3
    rounded-xl
    bg-[#febe10]
    px-5
    py-2.5
    font-semibold
    text-[#004270]
    shadow-md
    transition-all
    duration-300
    hover:scale-105
    hover:shadow-lg
  "
          >
            Inscríbete ahora
          </HashLink>
        </nav>

        {/* Botón hamburguesa */}
        <button
          onClick={() => setOpen(!open)}
          className="flex md:hidden flex-col justify-center gap-1.5 p-2"
          aria-label="Abrir menú"
        >
          <span
            className={`h-0.5 w-6 bg-white transition-all duration-300 ${
              open ? "translate-y-2 rotate-45" : ""
            }`}
          />
          <span
            className={`h-0.5 w-6 bg-white transition-all duration-300 ${
              open ? "opacity-0" : ""
            }`}
          />
          <span
            className={`h-0.5 w-6 bg-white transition-all duration-300 ${
              open ? "-translate-y-2 -rotate-45" : ""
            }`}
          />
        </button>
      </div>

      {/* Menú móvil */}
      <AnimatePresence>
        {open && (
          <motion.nav
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: "auto" }}
            exit={{ opacity: 0, height: 0 }}
            transition={{ duration: 0.3 }}
            className="
              md:hidden
              overflow-hidden
              border-t
              border-white/10
              bg-[#004270]
            "
          >
            <div className="flex flex-col p-4">
              <HashLink
                smooth
                to="/ "
                className="text-white p-3 hover:text-[#febe10]"
              >
                Inicio
              </HashLink>
              <HashLink
                smooth
                to="/#call-for-papers"
                className="text-white p-3 hover:text-[#febe10]"
              >
                Call for papers
              </HashLink>

              <HashLink
                className="
                  mt-5
                  rounded-xl
                  bg-[#febe10]
                  py-3
                  text-center
                  font-semibold
                  text-[#004270]
                  shadow-md
                  transition-all
                  duration-300
                  hover:shadow-lg
                "
                smooth
                to="/#inscripcion"
              >
                Inscríbete ahora
              </HashLink>
            </div>
          </motion.nav>
        )}
      </AnimatePresence>
    </motion.header>
  );
}

export default Header;
